import { InjectionToken } from '@angular/core';
import { Iban, SortCodeWeightTable } from '@formunauts/banking/domain';
import { CountryBankData } from './bank-data/country-bank-data';

export const IBAN_COUNTRY_REGISTRY_TOKEN = new InjectionToken<
  ReadonlyMap<string, Iban.IbanCountryMeta>
>('@formunauts/shared/banking/data-access/iban-country-registry');

export const BANKS_COUNTRY_REGISTRY_TOKEN = new InjectionToken<
  ReadonlyMap<string, CountryBankData>
>('@formunauts/shared/banking/data-access/banks-country-registry');

/**
 * Injection token to acquire the weight table for sort code validation.
 */
export const SORT_CODE_WEIGHT_TABLE = new InjectionToken<SortCodeWeightTable>(
  '@formunauts/shared/banking/data-access/l10n/gb/validate/sort-code-weight-table',
);
